import { createFileRoute, redirect } from "@tanstack/react-router";
import { legacyDevelopersApiRedirectTarget } from "@/lib/docs-paths";
import { isPublicApiSurfaceEnabled } from "@/lib/modules";

export const Route = createFileRoute("/_marketing/developers/api/$")({
	beforeLoad: ({ params }) => {
		if (!isPublicApiSurfaceEnabled()) {
			throw redirect({ to: "/" });
		}
		throw redirect({
			...legacyDevelopersApiRedirectTarget(params._splat),
			replace: true,
		});
	},
});
